import i18n from '@/i18n';

const KB_HOST = 'support.electric.ai/';
// The KB home page (no article path) localizes via a query param instead of
// a path segment. The optional existing `?l=` group means re-running this on
// an already-processed home URL just overwrites it instead of appending a
// second one.
const KB_HOME_PATTERN =
  /^(https?:\/\/support\.electric\.ai\/)(?:\?l=(?:en|fr|es))?$/;
// Matches the whole locale + working-version prefix of an electricithub
// article URL (both optional) in one pass, so replacing it is naturally
// idempotent. Anchored to the KB host and the electricithub path so it can't
// accidentally match the home page or an unrelated URL that happens to
// contain "electricithub/" elsewhere (e.g. a query param).
const KB_ARTICLE_PATTERN =
  /support\.electric\.ai\/(?:en\/|fr\/|es\/)?electricithub\/(?:working-version\/)?/;

function getSupportCenterLanguage(): 'en' | 'fr' | 'es' {
  const lang = i18n.language || 'en';
  const baseLang = lang.split('-')[0];
  if (baseLang === 'fr') return 'fr';
  if (baseLang === 'es') return 'es';
  return 'en';
}

/**
 * `url` must be one of the app's hardcoded support.electric.ai literals,
 * passed fresh on each call. This function doesn't revert an
 * already-localized URL back to English/another locale, so don't cache or
 * reuse a previously-returned value across a language change.
 */
export function getLocalizedSupportUrl(url: string): string {
  const language = getSupportCenterLanguage();
  // English KB links already resolve correctly as hardcoded (via a
  // server-side redirect), so leave them untouched rather than rewriting.
  if (language === 'en') return url;

  const homeMatch = url.match(KB_HOME_PATTERN);
  if (homeMatch) {
    return `${homeMatch[1]}?l=${language}`;
  }

  return url.replace(
    KB_ARTICLE_PATTERN,
    `${KB_HOST}${language}/electricithub/working-version/`
  );
}
